<div class="settings-section" [class.disabled]="isSmall()">
    <div class="settings-group">
        <label class="checkbox-label">
            <input type="checkbox" [formControl]="showDistributionDataForm.controls.showListingData" />
            <span>{{ 'dashboard.visuals.editModal.distributionSettings.showListingData' | translate }}</span>
        </label>
        <label class="checkbox-label">
            <input type="checkbox" [formControl]="showDistributionDataForm.controls.showPhotoData" />
            <span>{{ 'dashboard.visuals.editModal.distributionSettings.showPhotoData' | translate }}</span>
        </label>
    </div>

    @if (availableDistributors().length > 0) {
        <div class="settings-group">
            <div class="settings-group-header">
                <span class="settings-group-title">{{ 'dashboard.visuals.editModal.distributionSettings.distributors' | translate }}</span>
                <div class="settings-group-actions">
                    <button type="button" class="link-button" [disabled]="isSmall()" (click)="selectAllDistributors()">
                        {{ 'dashboard.visuals.editModal.distributionSettings.selectAll' | translate }}
                    </button>
                    <button type="button" class="link-button" [disabled]="isSmall()" (click)="deselectAllDistributors()">
                        {{ 'dashboard.visuals.editModal.distributionSettings.deselectAll' | translate }}
                    </button>
                </div>
            </div>
            <div class="settings-group-box">
                @for (item of distributorItems(); track item.distributorId) {
                    <label class="checkbox-label">
                        <input type="checkbox" [formControl]="item.control" />
                        <span>{{ item.distributorName }}</span>
                    </label>
                }
            </div>
        </div>
    }
</div>
